import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'

import './WebMenu.css'
import QbLink from '../QbLink/QbLink'

import {
  RECEIVE_WALLET_NAV, 
  BACKUP_WALLET_NAV, 
  PASSWORD_CHANGE_NAV, 
  PRIVATE_KEY_NAV
} from '../../../constants/navigation'

class WebMenu extends Component {
  render() {
    const { open, t, wide } = this.props 
    return (
      open ?
        <div className={`web-menu-container ${getWideMenuClass(wide)}`}>
          <QbLink style={STYLE.LINK} to={RECEIVE_WALLET_NAV} name={t('nav.receive')} />
          <QbLink style={STYLE.LINK} to={BACKUP_WALLET_NAV} name={t('nav.backup')} />
          <QbLink style={STYLE.LINK} to={PASSWORD_CHANGE_NAV} name={t('nav.password')} />
          <QbLink style={STYLE.LINK} to={PRIVATE_KEY_NAV} name={t('nav.private-key')} />
        </div>
        : null
    )
  }
}

const mapStateToProps = ({ menuReducer }) => {
  return {
    open: menuReducer.open
  }
}

export default connect(mapStateToProps)(translate()(WebMenu));

const getWideMenuClass = wide => wide ? 'web-menu-container--wide' : ''

const STYLE = {
  LINK: {
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'var(--qb-black-color)',
    fontSize: '14px',
    fontWeight: 'normal',
    borderBottom: '1px solid var(--db-border-color)'
  }
}


// WEBPACK FOOTER //
// ./src/components/shared/WebMenu/WebMenu.js